import api from '../api';

const searcherState = {
  savedSearches: [],
};

export default {
  namespaced: true,
  state: Object.assign({}, searcherState),
  actions: {
    async SAVE_SEARCH({ commit }, {
      name, filters, sort, searcher,
    }) {
      const search = await api.savedSearches.create(name, filters, sort, searcher);
      commit('ADD_SAVED_SEARCH', search);
      return search;
    },
    async EDIT_SAVED_SEARCH({ commit, state }, payload) {
      const editedSearch = await api.savedSearches.edit(payload);
      const searches = state.savedSearches.map((search) => {
        if (search.uuid === editedSearch.uuid) {
          return editedSearch;
        }
        return search;
      });
      commit('SET_SAVED_SEARCHES', searches);
    },
    async FETCH_SAVED_SEARCHES({ commit }) {
      const searches = await api.savedSearches.all();
      commit('SET_SAVED_SEARCHES', searches);
    },
    async REMOVE_SAVED_SEARCH({ commit }, uuid) {
      await api.savedSearches.remove(uuid);
      commit('REMOVE_SAVED_SEARCH', uuid);
    },
  },
  getters: {
    savedSearchByUuid: state => uuid => state.savedSearches.find(search => search.uuid === uuid),
    savedSearchesBySearcher: state => searcher => state.savedSearches.filter(search => search.searcher === searcher),
    actions: (state, getters, rootState, rootGetters) => entity => rootGetters.searcher[entity].actions || [],
    globalActions: (state, getters, rootState, rootGetters) => entity => rootGetters.searcher[entity].globalActions || [],
  },
  mutations: {
    ADD_SAVED_SEARCH: (state, search) => {
      state.savedSearches.push(search);
    },
    REMOVE_SAVED_SEARCH: (state, uuid) => {
      state.savedSearches = state.savedSearches.filter(search => search.uuid !== uuid);
    },
    SET_SAVED_SEARCHES: (state, searches) => {
      state.savedSearches = searches;
    },
  },
};
